import { ActionTrackingRequest, ACTION_STATUS } from '@/lib/models';
import { trackingService } from '@/lib/services';
import config from '@/lib/config';

const MAX_ERROR_MESSAGE_LENGTH = 500;

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
function isValidEmail(value: string) {
	return EMAIL_REGEX.test(value);
}

// Pull a short error code + human message from Amplify errors (.code/.name/.message)
// or ErrorConfig (.code/.message)
export function toErrorFields(error: unknown) {
	const err = error as { code?: string; name?: string; message?: string };
	const errorMessage = err?.message ? String(err.message).slice(0, MAX_ERROR_MESSAGE_LENGTH) : undefined;
	return {
		errorCode: err?.code ?? err?.name,
		errorMessage,
	};
}

// Fire-and-forget. Never throws and is never awaited by callers, so a tracking
// failure can never block or break an auth flow. Status defaults to SUCCESS.
// Gated by REACT_APP_HACKETT_TRACKING_ACTIVITY — opt-in, no-ops unless set to 'true'.
export function trackAction(data: ActionTrackingRequest) {
	if (config.HACKETT_ACTION_TRACKING_ENABLED !== 'true') {
		return;
	}

	// emailAddress that isn't a valid email is most likely a Cognito user id (uuid).
	// Move it to cognitoUserId and drop the emailAddress key.
	const payload = { ...data };
	if (payload?.emailAddress && !isValidEmail(payload?.emailAddress)) {
		payload.cognitoUserId = payload.emailAddress;
		delete payload.emailAddress;
	}

	try {
		trackingService
			.track({ status: ACTION_STATUS.SUCCESS, ...payload })
			.fetch()
			.catch(() => {
				/* swallow — tracking is best-effort */
			});
	} catch {
		/* swallow — tracking must never affect the flow */
	}
}
